import React, { useState, useMemo, act } from 'react';

import EquipmentWrapper from './wrappers/equipmentWrapper';
import BuffWrapper from './wrappers/buffWrapper';
import CookieWrapper from './wrappers/cookieWrapper';
import ArtifactWrapper from './wrappers/artifactWrapper';
import StatWrapper from './wrappers/statsWrapper';
import DamageWrapper from './wrappers/damageWrapper';
import EnemyWrapper from './wrappers/enemyWrapper';
import SeasoniteWrapper from './wrappers/seasoniteWrapper';
import ExternalWrapper from './wrappers/externalWrapper';
import './css/rarityColors.css';
//Character context is used for additional sorting for other selectors, like blanking out artifacts if the role doesn't match


const CharacterStats = () => {
  const [gearStats, setGearStats] = useState({ stats: [], buffs: [] });
  const [activeBuffs, setActiveBuffs] = useState([]);
  const [trueStats, setTrueStats] = useState(null);
  const [externalStats, setExternalStats] = useState([]);
  const [character, setCharacter] = useState(null);
  const [artifact, setArtifact] = useState(null); 
  const [seasonite, setSeasonite] = useState(null); 
  const [enemyStats, setEnemyStats] = useState({DEF: 300, RES: 20, area: 30}); 


  const getArtifactBuffs = (artifact, characterRole) => {
    switch (true) {
      case !artifact:
        console.log("artifact is null or undefined");
        return [];

      case !characterRole:
        console.log("characterRole is null or undefined");
        return [];

      case artifact.role !== characterRole && artifact.role !== "All" && artifact.cookie !== character.name:
        return [];

      default:
        break;
    }


    return artifact.buffs.map(buff => {
      return {
        name: buff.name,
        stats: buff.stats,
        targets: buff.targets,
        type: buff.type,
        stackLimit: buff.stackLimit,
        dependant: buff.dependant || false
      };
    });
  };

  const getCharacterBuffs = cookie => (cookie?.buffs ? cookie.buffs : []);

  const characterContext = useMemo(() => {
    return {
      name: character?.name,
      role: character?.role,
      element: character?.element,
      class: character?.class,
      rarity: character?.rarity
    };
  }, [character]);

  const artifactBuffs = useMemo(
    () => (artifact && character?.role ? getArtifactBuffs(artifact, character.role) : []),
    [artifact, character]
  );

  const characterBuffs = useMemo(
    () => (character ? getCharacterBuffs(character) : []),
    [character]
  );

  const combinedBuffs = useMemo(
    () => [...artifactBuffs, ...gearStats.buffs, ...characterBuffs, ...(seasonite?.buffs || [])],
    [artifactBuffs, gearStats.buffs, characterBuffs, seasonite]
  );

  const mergedAttacks = useMemo(() => {
    if (!character?.attacks) return {};

    const merged = { ...character.attacks };

    
    if (artifact?.attacks && artifact.cookie === character.name) {
      Object.entries(artifact.attacks).forEach(([category, attacks]) => {
        if (!merged[category]) {
          merged[category] = [];
        }
        merged[category] = [...merged[category], ...attacks];
      });
    }
    if (gearStats?.attacks) {
      Object.entries(gearStats.attacks).forEach(([category, attacks]) => {
        if (!merged[category]) {
          merged[category] = [];
        }
        merged[category] = [...merged[category], ...attacks];
      });
    }

    return merged;
  }, [character?.attacks, artifact?.attacks, gearStats?.attacks]);


  const renderEquipment = useMemo(() => {
    return (
      character && artifact
    );
  }, [character, artifact]);

  const renderStats = useMemo(() => {
    return (
      gearStats?.stats?.length > 0 &&
      activeBuffs?.length >= 0
    );
  }, [gearStats, activeBuffs]);

  const renderDamage = useMemo(() => {
    return (
      Object.keys(trueStats || {}).length > 0 &&
      combinedBuffs !== null    );
  }, [trueStats, combinedBuffs]);

  return (
    <div className="main">
      <div className='charArtiSelector basicWrapper'>
      <CookieWrapper getCookieData={setCharacter} />
      <ArtifactWrapper getArtifactData={setArtifact} context={characterContext} />
      <SeasoniteWrapper getSeasoniteData={setSeasonite}/>
      </div>
      {renderEquipment ? (
        <>
          <EquipmentWrapper setGearStats={setGearStats} context={characterContext} />

          <BuffWrapper buffs={combinedBuffs} setActiveBuffs={setActiveBuffs} />

          <ExternalWrapper setExternalStats={setExternalStats} />

          <EnemyWrapper passEnemyStats={setEnemyStats} />

          {renderStats ? (
            <StatWrapper
              base={character.stats}
              setTrueStats={setTrueStats}
              modifiers={[...gearStats.stats, ...(artifact?.base || []), ...(seasonite?.stats || []), ...externalStats.stats]}
              buffs={[...activeBuffs, ...externalStats.buffs]}
              context={characterContext}
            />
          ) : (
            <div>Loading stats...</div>
          )}
        </>
      ) : (
        <div>Loading character data...</div>
      )}
      {renderDamage ? (
        <DamageWrapper
          trueStats={trueStats}
          enemyStats={enemyStats}
          mergedAttacks={mergedAttacks}
        />
      ) : (
        <div>Loading Damage data...</div>
      )}
    </div>
  );
};

export default CharacterStats;
